import styled from "styled-components";

export const DuplicateApplianceListModalStyle = styled.div`

`;
